import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import * as fromSearch from '@app/store/actions/search.action';
import * as fromRouter from '@app/store/actions/router.action';
import { Router } from '@angular/router';

@Injectable()
export class SearchService {
  public lastSearch: any;

  constructor(private state: Store<IAppState>, private router: Router) {}

  registerSearch(query: { query: string; nbHits: any }) {
    this.state.dispatch(
      new fromSearch.AddCurrentSearchToLastSearches({
        query: query.query,
        nbHits: query.nbHits,
        date: new Date()
      })
    );
  }

  leaveSearch() {
    this.state.dispatch(new fromRouter.Back());
    this.state.dispatch(new fromSearch.SetIsSearchInProgress(false));
  }

  launchSearchPage() {
    if (this.router.url !== '/search/') {
      this.router.navigate(['/search/', ''], { queryParams: { q: 'test' } });
    }
  }
}
